import React, { useContext, useEffect, useState } from "react";
import { FiltersIcon } from "shared-components/Components/CustomIcons/FiltersIcon/web";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useActiveFiltersTags } from "shared-components/ViewFragments/SearchResults/Sider/ActiveFiltersTags/ActiveFiltersTags.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import CalendarIcon from "shared-components/Components/CustomIcons/CalendarIcon/web";
import { TemporalFilter } from "shared-components/Components/Filters/TemporalFilter/web";
import CashIcon from "shared-components/Components/CustomIcons/CashIcon";
import { Price } from "shared-components/Components/Filters/Price/web_2";
import { showBedrooms, showRooms } from "@Utils/Functions";
import { Rooms } from "shared-components/Components/Filters/Rooms/web";
import PoolIcon from "shared-components/Components/CustomIcons/PoolIcon/web";
import { Guests } from "shared-components/Components/Filters/Guests/web";
import PersonIcon from "shared-components/Components/CustomIcons/PersonIcon";
import M2Icon from "shared-components/Components/CustomIcons/M2Icon";
import { SurfaceRange } from "shared-components/Components/Filters/SurfaceRange/web";
import { Bedrooms } from "shared-components/Components/Filters/Bedrooms/web";
import { Bathrooms } from "shared-components/Components/Filters/Bathrooms/web";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
import { Amenities } from "shared-components/Components/Filters/Amenities/web";
import { useAmenities } from "shared-components/Components/Filters/Amenities/Amenities.hook";
import { getLabelPriceRange, getLabelSeasonsAndDates, getLabelSurfaceRange, labelForBedroomsAndBathrooms } from "src/utils/Functions";
import { currencyType } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/options";
import { MapIcon } from "shared-components/Components/CustomIcons/MapIcon/web";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";
import { usePendingFilters } from "shared-components/Contexts/PendingFilters/PendingFiltersContext";
import { SlidersHorizontal } from "shared-components/Components/CustomIcons/SlidersHorizontal/web";
import PlusOutlinedIcon from "shared-components/Components/CustomIcons/PlusOutlinedIcon/web";

export const useFilterBar = ({closeSingleFilterModal} : {closeSingleFilterModal: (doCloseFunction?: boolean) => void}) => {
    const { filtersTags, filters, showFilter } = useFilters();
    const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
    const { applyPendingFilters } = usePendingFilters();
    const {filtersTagsToShow} = useActiveFiltersTags();
    const { country_code } = useContext(ConfigStateContext);
    const {ammenitieActiveIsNotMain} = useAmenities({country_code});
    const [showSingleFilterModal, setShowSingleFiltersModal] = useState(false);
    const [filterComponent, setFilterComponent] = useState(null);
    const [filterValues, setFilterValues] = useState(null)
    const appliedFilters = [...new Set(filtersTagsToShow?.filter(e => e.deleteable)?.map(e => e.key))].length
    const currenciesByCountry = currencyType.filter(currency => currency.countries.includes(country_code ? country_code.toUpperCase() : ""))
    const currenciesList = currenciesByCountry.map((currency) => ({ text: currency.text, value: currency.value, smallText: currency.smallText }));
	const isRooms = showRooms(filters?.property_type_id, country_code);
	const isBedrooms = showBedrooms(filters?.property_type_id, filters?.operation_type_id, country_code);

    useEffect(() => {
        if (isRooms && filterValues?.bedrooms) {
            setFilterValues((prevValues) => ({
                ...prevValues,
                bedrooms: [],
                bedroomsExactMode: false
            }));
        }

        if (isBedrooms && filterValues?.rooms) {
            setFilterValues((prevValues) => ({
                ...prevValues,
                rooms: [],
                roomsExactMode: false
            }));
        }
    }, [isRooms, isBedrooms]);

    const openSingleFilter = (id) => {
        const filter = items.find(f => f.id === id);
        if (filter && filter.main) {
        } else if(filter) {
            if(filter.component === null && typeof filter.onDelete === 'function') {
                filter.onDelete();
            } else {
                setFilterComponent(filter);
                document?.body?.classList.add('no-scroll')
                setShowSingleFiltersModal(true);
            }
            
        }
    };

    const getCurrencyInfo = () => {
        let current = currenciesList[0];
        let symbol = '';
        const getCurrencySymbol = (currencyText) => currencyText.split(' ')[0];

        if (filtersTags?.currencyID?.value) {
            current = currenciesList.find((currency) => currency.value === filtersTags.currencyID.value) || currenciesList[0];
        }

        if (current) symbol = getCurrencySymbol(current.text);

        return {symbol, currency: current}
    }

    /**
     * Calcula el label para el filtro de precio según si esta aplicado precio minimo y/o máximo
    */
    const labelForPrice = () => {
        const {symbol} = getCurrencyInfo();
        const label: string = getLabelPriceRange(filtersTags?.minPrice?.value, filtersTags?.maxPrice?.value, symbol);
        return label;
    }

    const handleSetFilterValues = (values) => {
        setFilterValues((prevState) => ({...prevState, ...values}))
    }

    const handleApplyFilter = () => {
        closeSingleFilterModal(true);
        if (filterValues) changeFiltersAndUpdateURL(filterValues)
        if (['priceRange', 'm2Range', 'guests'].includes(filterComponent?.id)) {
            applyPendingFilters();
        }
    }

    const items = [
        {
            id: 'main',
            label: 'Filtros',
            icon: <SlidersHorizontal />,
            postIcon: 
                appliedFilters > 0 ? 
                <div style={{backgroundColor: '#35394E', display:'flex', borderRadius:20, width: 20, height: 20, alignItems: 'center', justifyContent:'center'}}>
                    <span style={{color:'white', fontSize: 14, lineHeight: 16}}>{appliedFilters}</span>
                </div> : null,
            active: false,
            main: true,
            OpenFilters:true
        },
        {
            id: 'dibujomapa',
            label: 'Dibujo en mapa',
            icon: <MapIcon />,
            active: true,
            hidden: !filters?.map_polygons,
            component: null,
            onDelete: () => {
                changeFiltersAndUpdateURL({
                    map_polygons: null
                })
            },
        },
        {
            id: 'dates',
            hidden: !showFilter.temporal,
            label: getLabelSeasonsAndDates(filtersTags),
            icon: <CalendarIcon />,
            active: filtersTags?.dateFrom || filtersTags?.dateTo || filtersTags?.season,
            component:<TemporalFilter
                filterChanged={changeFiltersAndUpdateURL}
                show={showFilter.temporal}
            />,
            onDelete: () => {
                changeFiltersAndUpdateURL({
                season: null,
                dateFrom: null,
                dateTo: null,
            });
            }
        },
        {
            id: 'guests',
            hidden: !showFilter.guests,
            label: filtersTags?.guests?.value ? (filtersTags?.guests.value + '+ ' + ('Huéspedes')) : ('Huéspedes'),
            icon: <PersonIcon />,
            active: filtersTags?.guests?.value,
            component: <Guests
                changeFilters={changeFiltersAndUpdateURL}
                filters={filters}
                show={showFilter.guests}
                allowOnBlur={false}
            />,
            onDelete: () => {
                changeFiltersAndUpdateURL({
                    guests: null,
                });
            }
        },
        {
            id: 'priceRange',
            label: labelForPrice(),
            hidden: !showFilter.price,
            icon: <CashIcon />,
            active: filtersTags.minPrice || filtersTags.maxPrice,
            onlyText: false,
            nonDeletable: false,
            isBool: false,
            component: <Price filters={filters} changeFilters={changeFiltersAndUpdateURL} show={showFilter.price} />,
            onDelete: () => {
                changeFiltersAndUpdateURL({
                    minPrice: null,
                    maxPrice: null,
                    commonExpenses: false,
                });
            },
            onClose: () => {
            }
        },
        {
            id: 'bedAndBaths',
            hidden: !showFilter.bedroom && !showFilter.bathrooms && !showFilter.rooms,
            label: labelForBedroomsAndBathrooms(filtersTags, isRooms),
            icon: <BedIcon/>,
            active: filtersTags.bedrooms?.length || filtersTags.rooms?.length  || filtersTags.bathrooms?.length,
            component: (
                <div style={{overflow: 'hidden'}}>
                    <Bedrooms inputType="buttonGroup" filterChanged={changeFiltersAndUpdateURL} /* triggerApplyFilter={handleSetFilterValues} */ show={showFilter.bedroom} /> {/* Se comenta el triggerApplyFilter para que no golpee el estado interno */}
                    <Rooms inputType="buttonGroup" filterChanged={changeFiltersAndUpdateURL} /* triggerApplyFilter={handleSetFilterValues} */ show={showFilter.rooms} /> 
                    <Bathrooms inputType="buttonGroup" filterChanged={changeFiltersAndUpdateURL} /* triggerApplyFilter={handleSetFilterValues} */ show={showFilter.bathrooms} />
                </div>
            ),
            onDelete: () => {
            changeFiltersAndUpdateURL({
                bedrooms: [],
                bathrooms: [],
                rooms: [],
            });
            }
        },
        {
            id: 'comodities',
            label: 'Extras',
            hidden: !showFilter.amenities,
            icon: <PlusOutlinedIcon width={16} />,
            active: filtersTags?.facilitiesGroup?.length || filtersTags?.seen || filtersTags?.privateOwner || filtersTags?.socialHousing || filtersTags?.hasGarage,
            component: (
                <div style={{maxHeight: 350}}>
                    <Amenities changeFilters={changeFiltersAndUpdateURL} filters={filters} filtersTags={filtersTags} openByDefault={ammenitieActiveIsNotMain} show={showFilter.amenities} triggerApplyFilter={handleSetFilterValues} />
                </div>
            ),
            onDelete: () => {
                changeFiltersAndUpdateURL({
                    facilitiesGroup: [],
                    hasGarage: null,
                    tour3d: null,
                    privateOwner: null,
                    socialHousing: null,
                    seen: null,
                    seaview: null
                });
            }
        },
        {
            id: 'm2Range',
            label: getLabelSurfaceRange(filtersTags?.m2Min, filtersTags?.m2Max),
            hidden: (filters.property_type_id && !filters.property_type_id.includes(3)) || !filters.property_type_id,
            icon: <M2Icon />,
            active: filtersTags.m2Min || filtersTags.m2Max,
            component: <SurfaceRange filterChanged={changeFiltersAndUpdateURL} /* triggerApplyFilter={handleSetFilterValues} */ show={showFilter.surfaceRange} />,
            onDelete: () => {
                changeFiltersAndUpdateURL({
                    m2Min: null,
                    m2Max: null
                });
            },
        },
        {
            id: 'moreFilters',
            label: 'Más Filtros',
            icon: <SlidersHorizontal width={16} />,
            active: false,
            isBool: true,
            component: null,
            onlyText: true,
            OpenFilters:true
        },
    ];

    return {
        items,
        showSingleFilterModal,
        setShowSingleFiltersModal,
        openSingleFilter,
        filterComponent,
        handleApplyFilter
    };
}